import { ImgHTMLAttributes, useState } from 'react';
import { Skeleton } from './Skeleton';

interface MediaImageProps extends ImgHTMLAttributes<HTMLImageElement> {
  src: string;
}

export function MediaImage({ src, alt = '', className = '', onError, onLoad, ...props }: MediaImageProps) {
  const [loadedSource, setLoadedSource] = useState<string | null>(null);
  const [failedSource, setFailedSource] = useState<string | null>(null);
  const isBusy = loadedSource !== src && failedSource !== src;
  return <span className="skeleton-media-frame">
    {isBusy ? <Skeleton className="skeleton-media-overlay" /> : null}
    {failedSource === src ? <span className="media-image-fallback" role="img" aria-label={alt || 'Изображение недоступно'}>◇</span> : <img {...props} alt={alt} src={src} className={`${className}${isBusy ? ' skeleton-media-pending' : ''}`} ref={(image) => {
      if (image?.complete && image.naturalWidth > 0 && loadedSource !== src) setLoadedSource(src);
    }} onLoad={(event) => { setLoadedSource(src); onLoad?.(event); }} onError={(event) => { setFailedSource(src); onError?.(event); }} />}
  </span>;
}
